<script>
  import ProductBundleList from './ProductBundleList.svelte';
  import AddToBasketButton from './AddToBasketButton.svelte';
  import PrimaryProduct from './PrimaryProduct.svelte';
  import BundleTotalPrice from './BundleTotalPrice.svelte';
  import { setContext } from 'svelte';
  import { key as featuresStateCtx } from '../context/featuresState.js';
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */

  /*                */
  let {
    variationId,
    mainVariation,
    recommendations,
    tracking,
    additionalClickTracking,
    featureIndex,
    featuresState
  } = $props();

  setContext(featuresStateCtx, featuresState);

  let totalPrice = $state(
    recommendations.reduce(
      (
        /*              */ accumulator,
        /*                                                                                */ recommendation
      ) => {
        return accumulator + recommendation._embedded['o:variation'].pricing.retailPrice;
      },
      mainVariation?.pricing?.retailPrice
    )
  );

  let recommendationIds = $state(recommendations.map((r) => r._embedded['o:variation'].id));

  const toggleCheck = (
    /*              */ variationId,
    /*                 */ variationPrice,
    /*              */ checked
  ) => {
    if (checked) {
      recommendationIds.push(variationId);
      totalPrice += variationPrice;
    } else {
      recommendationIds = recommendationIds.filter((id) => id !== variationId);
      totalPrice -= variationPrice;
    }
    recommendationIds = recommendationIds;
  };
</script>

<div id="reco_aos_bundle" class="oc-mt-50">
  <PrimaryProduct {mainVariation} />
  <ProductBundleList
    {recommendations}
    {featureIndex}
    widgetTracking={tracking}
    widgetAdditionalClickTracking={additionalClickTracking}
    {toggleCheck} />
  <BundleTotalPrice {totalPrice} />
  <AddToBasketButton
    {variationId}
    {recommendationIds}
    widgetAdditionalClickTracking={additionalClickTracking}
    {totalPrice} />
</div>
